import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideQueryService } from 'src/app/core/services/query.service';
import { TestApiService } from './test-api.service';
import { CRUD_FILE_ENDPOINT, CRUD_FORM_ENDPOINT, fileStateConfig, formStateConfig } from './test-api.config';



@NgModule({
  declarations: [],
  providers: [
    ...provideQueryService<any>(CRUD_FILE_ENDPOINT, fileStateConfig),
    ...provideQueryService<any>(CRUD_FORM_ENDPOINT, formStateConfig),
    TestApiService

  ],
  imports: [
    CommonModule,
  ]
})
export class TestApiModule { }